import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PLATFORM_ID, APP_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { NguCarouselModule } from '@ngu/carousel';
import { Angular2FontawesomeModule } from 'angular2-fontawesome';
import { NgStringPipesModule } from 'angular-pipes';
import { NgxSpinnerModule } from 'ngx-spinner';

import { ImpactedLivesService } from './services/impacted-lives.service';
import { needsService } from './services/needs.service';
import { HomePageBannerService } from './services/home-page-banner.service';
import { NeedsectorService } from './services/needsector.service';
import { AchievementsService } from './services/achievements.service';
import { HomepageFactsFiguresService } from './services/homepage-facts-figures.service';
import { TestimonialsService } from './services/testimonials.service';
import { SocialFeedsService } from './services/social-feeds.service';

import { HomeComponent } from './home/home.component';
import { HeaderComponent } from './shared/header/header.component';
import { FooterComponent } from './shared/footer/footer.component';
import { IndexMainBannerComponent } from './home/index-main-banner/index-main-banner.component';
import { NeedsComponent } from './home/hope-and-shine/needs.component';
import { ImpactedLivesComponent } from './home/impacted-lives/impacted-lives.component';
import { JoinTheConversationComponent } from './home/join-the-conversation/join-the-conversation.component';
import { FundraisingWorksComponent } from './home/fundraising-works/fundraising-works.component';
import { TopListComponent } from './home/top-list/top-list.component';
import { AchievementsComponent } from './home/achievements/achievements.component';
import { TestimonialsComponent } from './home/testimonials/testimonials.component';
import { StartYourFundraisingComponent } from './home/start-your-fundraising/start-your-fundraising.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HowItWorksComponent } from './others/how-it-works/how-it-works.component';
import { ForgotPasswordComponent } from './others/forgot-password/forgot-password.component';
import { AnonnymousDonationComponent } from './others/anonnymous-donation/anonnymous-donation.component';
import { AuthenticateDonorUsersLeadService } from './services/authenticate-donor-users-lead.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SearchComponent } from './others/search/search.component';
import { PledgeYourSupportComponent } from './others/pledge-your-support/pledge-your-support.component';
import { PlaedgeSupportService } from './services/plaedge-support.service';
import { ImpactedLivesPageComponent } from './others/impacted-lives-page/impacted-lives-page.component';
import { ImpactedLivesDetailComponent } from './others/impacted-lives-detail/impacted-lives-detail.component';
import { FaqsComponent } from './others/faqs/faqs.component';
import { SitemapComponent } from './others/sitemap/sitemap.component';
import { JwSocialButtonsModule } from 'jw-angular-social-buttons';
import { CartService } from './services/cart.service';
import { AuthenticationService } from './services/authentication.service';
import { TokenInterceptor } from './shared/interceptors/token.interceptor';
import { AuthGuard } from './shared/guards/auth.guard';
import { SharedModule } from './shared/shared.module';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { DonorprofileService } from './services/donorprofile.service';
// import { GtagModule } from 'angular-gtag';
import * as $ from "jquery";

import { AuthInterceptor } from './middleware/auth-interceptor'
import { FrontPageDataService } from './services/front-page-data.service';


import { MatDatepickerModule, MatNativeDateModule, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';



// import { DonateComponent } from '../app/donate/donate.component';

@NgModule({
  imports: [
    BrowserModule.withServerTransition({ appId: 'world-vision-hosh' }),
    FormsModule,
    AppRoutingModule,
    HttpClientModule,
    NguCarouselModule,
    Angular2FontawesomeModule,
    NgStringPipesModule,
    BrowserAnimationsModule,
    NgxSpinnerModule,
    NgbModule.forRoot(),
    JwSocialButtonsModule,
    SharedModule,
    DeviceDetectorModule.forRoot(),
    MatDatepickerModule, MatNativeDateModule,
    //  GtagModule.forRoot({ trackingId: 'UA-132826604-1', trackPageviews: true })
  ],
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    IndexMainBannerComponent,
    NeedsComponent,
    ImpactedLivesComponent,
    JoinTheConversationComponent,
    FundraisingWorksComponent,
    TopListComponent,
    AchievementsComponent,
    TestimonialsComponent,
    StartYourFundraisingComponent,
    HowItWorksComponent,
    ForgotPasswordComponent,
    AnonnymousDonationComponent,
    SearchComponent,
    PledgeYourSupportComponent,
    ImpactedLivesPageComponent,
    ImpactedLivesDetailComponent,
    FaqsComponent,
    SitemapComponent,
    // DonateComponent
  ],
  providers: [
    ImpactedLivesService,
    needsService,
    HomePageBannerService,
    FrontPageDataService,
    NeedsectorService,
    AchievementsService,
    HomepageFactsFiguresService,
    TestimonialsService,
    SocialFeedsService,
    AuthenticateDonorUsersLeadService,
    PlaedgeSupportService,
    CartService,
    AuthGuard,
    AuthenticationService,
    DonorprofileService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(APP_ID) private appId: string) {
    const platform = isPlatformBrowser(platformId);
  }
}
